import React from "react";
import { motion } from "framer-motion";
import { ArrowForward, Groups2 } from "@mui/icons-material";

const Associations = ({ associations, status = "ready" }) => {
  const isLoading = status === "loading";
  const hasAssociations = associations.length > 0;

  return (
    <motion.section
      className="home-section-card associations-section"
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45 }}
      viewport={{ once: true }}
    >
      <div className="section-header">
        <span className="section-kicker">Trusted network</span>
        <h2>Our Associations</h2>
        <p>Organizations connected with the Udyog ecosystem.</p>
      </div>

      <div className="association-list">
        {hasAssociations &&
          associations.map((a, i) => (
            <motion.div
              key={a.id || a.name || i}
              className="association-item"
              initial={{ opacity: 0, x: -14 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.03 }}
              viewport={{ once: true }}
            >
              <div className="association-logo">
                {a.logo ? (
                  <img src={a.logo} alt={a.name || "Association"} />
                ) : (
                  <Groups2 fontSize="small" />
                )}
              </div>

              <span>{a.name || "Association partner"}</span>
              <ArrowForward className="association-arrow" fontSize="small" />
            </motion.div>
          ))}

        {isLoading &&
          Array.from({ length: 5 }).map((_, i) => (
            <div className="association-item association-skeleton" key={i}>
              <div className="association-logo" />
              <span />
            </div>
          ))}

        {!isLoading && !hasAssociations && (
          <div className="home-empty-state">
            {status === "error"
              ? "Associations are temporarily unavailable."
              : "Associations will appear here soon."}
          </div>
        )}
      </div>
    </motion.section>
  );
};

export default Associations;
